const CONFIG: any = {
  http: {
    baseURL: 'http://acme.us-east-2.elasticbeanstalk.com',
    lineDriveService: 'http://acme.us-east-2.elasticbeanstalk.com',
    'expense-manager': 'http://vendonexpense-env.eba-uvyg2apk.us-east-2.elasticbeanstalk.com',
  },
};

export default CONFIG;

